import script from "./TableDropdownMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableDropdownMenu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__